import { FetchingStatus } from 'hooks/useFetchApi/useFetchApi'
import {
    CloseTerminalCashReportContract,
    DefaultDeviceContract,
    MenuSlimContract,
    PosTerminalContract,
    PosTerminalUpdateContract,
    PrinterSlimContract,
    PaymentDeviceLookupContract,
} from 'models'
import {
    getCurrentPosTerminalActions,
    getCurrentPosTerminalStatusActions,
    getCurrentPosTerminalDeviceActions,
    POS_TERMINAL_SET_OPEN_CASH_DRAWER,
    UPDATE_DEFAULT_PRINTER_SETTING_FROM_BROADCAST_DATA,
} from 'store/actions/posTerminal.action'
import { IAction } from 'types/storeTypes'

interface IPosTerminalState {
    loading: boolean
    editPosTerminalDeviceLoading: boolean

    editPosTerminalDevice?: PosTerminalUpdateContract
    dependency: {
        printers: PrinterSlimContract[]
        menus: MenuSlimContract[]
        paymentDevices: PaymentDeviceLookupContract[]
    }
    currentPosTerminal?: PosTerminalContract
    isCashDrawerOpened?: boolean
    dataCloseSummary: CloseTerminalCashReportContract
    defaultDeviceLoading: FetchingStatus
    defaultDevice?: DefaultDeviceContract
}

const initialState: IPosTerminalState = {
    loading: false,
    editPosTerminalDeviceLoading: false,
    defaultDeviceLoading: FetchingStatus.IDLE,

    editPosTerminalDevice: undefined,
    dependency: {
        printers: [],
        menus: [],
        paymentDevices: [],
    },
    currentPosTerminal: undefined,
    isCashDrawerOpened: undefined,
    dataCloseSummary: {},
}

function posTerminalReducer(
    state: IPosTerminalState = initialState,
    action: IAction,
): IPosTerminalState {
    switch (action.type) {
        case UPDATE_DEFAULT_PRINTER_SETTING_FROM_BROADCAST_DATA:
            // skip update setting, if the setting is not used by current browser tab
            if (
                state.defaultDevice?.defaultReceiptPrinter?.printerID !==
                action.payload.printerID
            )
                return state

            return {
                ...state,
                defaultDevice: {
                    ...state.defaultDevice,
                    defaultReceiptPrinter: action.payload,
                },
            }
        case getCurrentPosTerminalActions.onPending:
        case getCurrentPosTerminalStatusActions.onPending:
            return {
                ...state,
                loading: true,
            }
        case getCurrentPosTerminalActions.onSuccess:
            return {
                ...state,
                currentPosTerminal: action.payload,
                loading: false,
            }
        case getCurrentPosTerminalStatusActions.onSuccess:
            return {
                ...state,
                loading: false,
                currentPosTerminal: {
                    ...state.currentPosTerminal,
                    status: action.payload,
                },
            }

        case getCurrentPosTerminalDeviceActions.onPending:
            return {
                ...state,
                defaultDeviceLoading: FetchingStatus.LOADING,
            }
        case getCurrentPosTerminalDeviceActions.onSuccess:
            return {
                ...state,
                defaultDeviceLoading: FetchingStatus.SUCCESS,
                defaultDevice: {
                    ...state.defaultDevice,
                    ...action.payload,
                },
            }

        case POS_TERMINAL_SET_OPEN_CASH_DRAWER: {
            return {
                ...state,
                isCashDrawerOpened: action.payload,
            }
        }
        default:
            return state
    }
}

export default posTerminalReducer
